<!--
   Created by qing on 2020/11/9
   Des: 流程待办
-->
<template>
  <div class="todo-task-container" v-wechat-title="title">
    <div class="work-station-page-container" v-if="todoType === 'WORKBENCH'">
      <van-tabs
        v-if="menuList && menuList.length"
        v-model="activeIndex"
        sticky
        animated
        @click="handleSelect">
        <van-tab
          v-for="tab in menuList"
          :name="tab.id"
          :title="tab.showText"
          :badge="tab.count ? tab.count > 99 ? '99+': tab.count : ''">
          <template v-if="loadingEnd">
            <div class="cc-header"  v-if="tab.id === '6'">
              <div style="display: flex; align-items: center;">
                <div style="margin-right: 10px; font-size: 14px; width: 60px; color: #4b4b4b;">
                  仅看未读
                </div>
                <van-switch
                  size="20px"
                  v-model="showUnread"
                  @change="showUnreadChange"
                  active-color="#13ce66"
                  active-value="YES"
                  inactive-value="NO"
                  inactive-color="#dcdee0"
                ></van-switch>
              </div>

              <el-button
                style="margin-left: 10px"
                type="text"
                icon="el-icon-document-checked"
                @click="allRead">
                全部标记已读
              </el-button>
            </div>
            <div
              v-if="dataList && dataList.length"
              :id="`listContainerBody${tab.id}`"
              :style="{height: tab.id === '6' ? 'calc(100% - 50px)' : '100%'}"
              class="list-container">
              <van-list
                v-model="loading"
                :finished="finished"
                :immediate-check="false"
                finished-text="没有更多了"
                @load="loadMoreData">
                <div class="card-container">
                  <div
                    class="card-item"
                    v-for="item in dataList"
                    :key="item.instanceId"
                    @click="onClickFormItem(item)">
                    <div class="title">
                      {{ item.titleContent }}
                    </div>
                    <div class="prompt-container">
                      <van-tag
                        style=" margin-top: -5px;"
                        v-if="formApplyStatusMap[item.formApplyStatus]"
                        :type="formApplyStatusMap[item.formApplyStatus].tagType"
                        plain>
                        {{ formApplyStatusMap[item.formApplyStatus].tagContent }}
                      </van-tag>
                      <div class="must-arrive" v-if="item.expireFlag === 'REMIND'">
                        <van-icon name="fire-o"></van-icon>
                        催办
                      </div>
                      <div class="will-timeout" v-if="item.expireFlag === 'TIMEOUT'">
                        <van-icon name="clock-o"></van-icon>
                        即将超时
                      </div>
                      <div class="will-timeout" v-if="item.expireFlag === 'OVERTIME'">
                        <van-icon name="clock-o"></van-icon>
                        已超时
                      </div>
                    </div>
                    <div class="form-name">
                      <div class="header-name">
                        {{ item.formName }}-{{item.stepName}}
                      </div>
                      <div v-if="item.deadLine !== 0" class="dead-line">
                        {{ item.deadLine === 0 ? '无' : formatTime(item.deadLine) }}
                      </div>
                    </div>

                    <div v-for="f in item.briefReportList" class="form-item-brief-report">

                      <div class="field-name">
                        {{f.fieldName}}：
                      </div>

                      <template v-if="f.fieldType === FORM_ITEM__IMAGE">
                        <div v-for="(img, idx) in f.fieldValue" @click="e => {e.stopPropagation()}">
                          <van-image
                                  style="margin-right: 10px"
                                  width="30px"
                                  height="30px"
                                  @click="previewImage(f.fieldValue, idx)"
                                  :src="img.imgUrl">
                          </van-image>
                        </div>
                      </template>
                      <template v-else>
                        <div class="field-value">{{f.fieldValue}}</div>
                      </template>

                    </div>

                    <div class="sub-des user">
                      <span style="color: #8f959e;">发起人：</span>
                      {{ item.userName }}
                    </div>

                    <div class="read-icon" v-if="tab.id === '6'">
                      <svg v-if="item.read === 'NO'" t="1647244104055" class="icon" viewBox="0 0 1300 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                           p-id="2610" width="40" height="40">
                        <path
                          d="M784.014714 99.204787l10.903312 18.428134-21.294732-2.559463-14.179425 16.124617-4.095141-21.089976-19.707865-8.497417 18.735269-10.442609 2.04757-21.345922 15.715103 14.58894 20.936408-4.658223-9.060499 19.451919zM1067.142514 642.37403l-18.428134 10.903312 2.559463-21.294732-16.073428-14.179425 21.038786-4.14633 8.497417-19.656676 10.442609 18.735269 21.345922 1.996381-14.588939 15.715103 4.658222 20.936408-19.451918-9.00931z"
                          fill="#FD9A08" p-id="2611"></path>
                        <path
                          d="M1067.142514 642.37403l-18.428134 10.903312 2.559463-21.294732-16.073428-14.179425 21.038786-4.14633 8.497417-19.656676 10.442609 18.735269 21.345922 1.996381-14.588939 15.715103 4.658222 20.936408-19.451918-9.00931zM571.886418 100.023815l-17.404348-12.541369 20.526893-6.1939 6.501036-20.424515 12.234233 17.609105 21.448301-0.153567-12.950883 17.097213 6.756982 20.373325-20.270947-7.012928-17.250781 12.694936 0.409514-21.4483zM991.382408 784.373039l-21.192354 3.480869 10.135474-18.888837-9.828338-19.093594 21.089975 3.788005 15.100832-15.254399 2.917788 21.243543 19.144783 9.623581-19.298351 9.367634-3.224923 21.192354-14.844886-15.459156zM427.993407 156.792705l-20.78284-5.323683 16.892456-13.258019-1.330921-21.397111 17.762674 11.927098 19.963811-7.883146-5.886765 20.629272 13.667533 16.534131-21.397111 0.819028-11.517584 18.069809-7.371253-20.117379zM854.19519 896.42633l-20.731651-5.323683 16.841267-13.258019-1.330921-21.397111 17.813863 11.978287 19.912622-7.934335-5.835575 20.629272 13.667532 16.534131-21.4483 0.819028-11.517584 18.069809-7.371253-20.117379zM562.416405 923.607827l10.903313 18.428134-21.294733-2.559463-14.179425 16.073428-4.14633-21.038786-19.656676-8.497418 18.735269-10.442609 1.996381-21.345921 15.715103 14.588939 20.936408-4.658223-9.00931 19.451919zM242.790663 420.724532l-18.479324 10.954502 2.559464-21.294733-16.073428-14.230614 21.038786-4.095141 8.497417-19.707865 10.442609 18.735269 21.345922 2.047571-14.588939 15.715103 4.709412 20.936407-19.451919-9.060499z"
                          fill="#FD9A08" p-id="2612"></path>
                        <path
                          d="M242.790663 420.724532l-18.479324 10.954502 2.559464-21.294733-16.073428-14.230614 21.038786-4.095141 8.497417-19.707865 10.442609 18.735269 21.345922 2.047571-14.588939 15.715103 4.709412 20.936407-19.451919-9.060499zM700.780976 943.878774l-17.404348-12.490179 20.475704-6.24509 6.552225-20.424515 12.234233 17.609106 21.448301-0.102379-12.950883 17.097213 6.756982 20.322136-20.270947-7.012928-17.30197 12.694936 0.460703-21.4483zM303.552315 278.827902l-21.192354 3.42968 10.135473-18.888837-9.828338-19.042405 21.089976 3.788006 15.100832-15.2544 2.917787 21.243543 19.144784 9.623581-19.298351 9.316445-3.224924 21.243544-14.844885-15.459157z"
                          fill="#FD9A08" p-id="2613"></path>
                        <path
                          d="M407.620081 90.604991a486.861057 486.861057 0 0 1 504.521352 11.77353l25.031548-14.435371a511.892605 511.892605 0 0 0-797.528678 459.57718l25.031548-14.384182A486.758678 486.758678 0 0 1 407.620081 90.604991zM893.201406 933.333787a486.861057 486.861057 0 0 1-504.521351-11.619963l-24.980359 14.384183A511.892605 511.892605 0 0 0 1161.177185 476.572015L1136.401583 490.956197a486.912246 486.912246 0 0 1-243.200177 442.37759z"
                          fill="#FD9A08" p-id="2614"></path>
                        <path
                          d="M813.909242 795.839433a326.587482 326.587482 0 0 1-258.147441 29.536203l-29.792149 17.199592a353.205897 353.205897 0 0 0 472.73282-272.429245l-29.792149 17.148403A326.843428 326.843428 0 0 1 813.909242 795.839433zM486.861057 228.099345a326.587482 326.587482 0 0 1 258.14744-29.536204l29.79215-17.199591A353.205897 353.205897 0 0 0 302.016637 453.792794l29.843339-17.148402a326.485103 326.485103 0 0 1 155.001081-208.545047zM1288.280119 374.705387a53.441588 53.441588 0 0 1-14.384182 11.978287l-1044.260914 601.934514a53.799913 53.799913 0 0 1-73.4054-19.759055L7.217686 710.660503a53.697534 53.697534 0 0 1 19.707865-73.405399L1071.442411 35.32059a53.799913 53.799913 0 0 1 73.4054 19.759054l148.80718 258.19863a53.953481 53.953481 0 0 1-5.374872 61.427113zM32.198045 665.716333a28.102904 28.102904 0 0 0-2.815409 32.146855l148.80718 258.19863a28.154093 28.154093 0 0 0 38.443134 10.237852L1261.149811 364.518724a28.154093 28.154093 0 0 0 10.237852-38.443135l-148.755991-258.249819a28.102904 28.102904 0 0 0-38.391945-10.237852L39.722866 659.420054a27.130308 27.130308 0 0 0-7.524821 6.296279z"
                          fill="#FD9A08" p-id="2615"></path>
                        <path
                          d="M451.079763 494.027553l16.329375-9.418824 17.353159 30.150475 75.45297-43.562061 8.906931 15.356778-75.45297 43.562061 22.472086 38.903838 87.021742-50.267854 8.906932 15.356778-72.586372 41.924004q46.070334 28.665986 119.11741 30.048096l-2.866599 20.475704q-79.445732-7.166496-128.945747-42.998978l-1.740435 0.972596 57.895053 100.33095-16.278184 9.418824L508.77006 593.795422l-1.996381 1.126163q7.576011 67.518635-28.512418 134.98608L460.703344 720.488841q35.832482-59.481921 33.784912-118.34957l-72.842317 42.077572-8.906932-15.356778 87.021743-50.319043-22.472085-38.955027-73.917292 42.691843-8.855742-15.356778 73.866103-42.640654zM661.160489 461.317616l46.428659-26.771984L762.719981 529.808846c1.074974-3.941573 2.149949-8.497417 3.276113-13.667532l1.740435-7.166497 1.842813-7.473632 14.025858 14.179425a331.296894 331.296894 0 0 1-16.943646 53.441588l-14.384182-10.698555a14.077047 14.077047 0 0 0-0.511892-12.029476l-50.677368-87.789582-31.020692 17.916241zM706.411795 392.928764l-4.453466 17.25078a252.055919 252.055919 0 0 0-56.308186-11.875908l4.760601-17.148402a305.702264 305.702264 0 0 1 56.001051 11.77353z m58.560514 88.813367l62.96279-36.395565a174.453 174.453 0 0 0-9.214067-20.475704l-21.704246-37.624106 15.356778-8.906932 22.011382 37.675296a185.561069 185.561069 0 0 1 9.367635 20.475704l53.492777-30.713556 8.343849 14.53775-56.7177 32.761127c0.358325 1.330921 0.767839 3.071356 1.228542 5.118926l0.71665 4.81179a375.422036 375.422036 0 0 1 83.489684 3.429681l-1.023786 18.479323a342.097828 342.097828 0 0 0-81.902816-6.449847 54.926077 54.926077 0 0 1-0.71665 9.470013q-5.118926 31.430206-37.112214 65.72701l-16.226996-8.24147q31.583774-32.812316 35.832483-60.864031a107.95815 107.95815 0 0 0-0.767839-22.16495l-58.970028 34.040858zM709.687907 363.44375l48.834555-28.205283-9.418824-16.278185 15.663914-9.00931 9.367634 16.278185 48.834555-28.205282 8.29266 14.332993-48.834554 28.205282 11.005691 19.144783 53.236831-30.713556 5.835575 10.237852a315.684169 315.684169 0 0 1 9.879528 49.807151l-17.762674 4.607033a186.072962 186.072962 0 0 0-6.142711-40.439516l-110.415235 63.935387-8.548607-14.742507L778.076759 368.562676l-11.05688-19.144784-48.834554 28.205283z m89.888342 79.54811l-1.023785 16.687699a182.336146 182.336146 0 0 0-46.786984-3.788005l1.38211-15.356778a176.142245 176.142245 0 0 1 46.428659 2.457084z m2.713031-32.914694l-1.126164 15.868671a157.81649 157.81649 0 0 0-43.920386-3.378492l1.382111-14.896074a195.645354 195.645354 0 0 1 43.664439 2.405895z"
                          fill="#FD9A08" p-id="2616"></path>
                      </svg>
                      <svg v-if="item.read === 'YES'" t="1647244277639" class="icon" viewBox="0 0 1300 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                           p-id="3487" width="40" height="40">
                        <path
                          d="M784.014714 99.204787l10.903312 18.428134-21.294732-2.559463-14.179425 16.124617-4.095141-21.089976-19.707865-8.497417 18.735269-10.442609 2.04757-21.345922 15.715103 14.58894 20.936408-4.658223-9.060499 19.451919zM1067.142514 642.37403l-18.428134 10.903312 2.559463-21.294732-16.073428-14.179425 21.038786-4.14633 8.497417-19.656676 10.442609 18.735269 21.345922 1.996381-14.588939 15.715103 4.658222 20.936408-19.451918-9.00931z"
                          fill="#13C463" p-id="3488"></path>
                        <path
                          d="M1067.142514 642.37403l-18.428134 10.903312 2.559463-21.294732-16.073428-14.179425 21.038786-4.14633 8.497417-19.656676 10.442609 18.735269 21.345922 1.996381-14.588939 15.715103 4.658222 20.936408-19.451918-9.00931zM571.886418 100.023815l-17.404348-12.541369 20.526893-6.1939 6.501036-20.424515 12.234233 17.609105 21.448301-0.153567-12.950883 17.097213 6.756982 20.373325-20.270947-7.012928-17.250781 12.694936 0.409514-21.4483zM991.382408 784.373039l-21.192354 3.480869 10.135474-18.888837-9.828338-19.093594 21.089975 3.788005 15.100832-15.254399 2.917788 21.243543 19.144783 9.623581-19.298351 9.367634-3.224923 21.192354-14.844886-15.459156zM427.993407 156.792705l-20.78284-5.323683 16.892456-13.258019-1.330921-21.397111 17.762674 11.927098 19.963811-7.883146-5.886765 20.629272 13.667533 16.534131-21.397111 0.819028-11.517584 18.069809-7.371253-20.117379zM854.19519 896.42633l-20.731651-5.323683 16.841267-13.258019-1.330921-21.397111 17.813863 11.978287 19.912622-7.934335-5.835575 20.629272 13.667532 16.534131-21.4483 0.819028-11.517584 18.069809-7.371253-20.117379zM562.416405 923.607827l10.903313 18.428134-21.294733-2.559463-14.179425 16.073428-4.14633-21.038786-19.656676-8.497418 18.735269-10.442609 1.996381-21.345921 15.715103 14.588939 20.936408-4.658223-9.00931 19.451919zM242.790663 420.724532l-18.479324 10.954502 2.559464-21.294733-16.073428-14.230614 21.038786-4.095141 8.497417-19.707865 10.442609 18.735269 21.345922 2.047571-14.588939 15.715103 4.709412 20.936407-19.451919-9.060499z"
                          fill="#13C463" p-id="3489"></path>
                        <path
                          d="M242.790663 420.724532l-18.479324 10.954502 2.559464-21.294733-16.073428-14.230614 21.038786-4.095141 8.497417-19.707865 10.442609 18.735269 21.345922 2.047571-14.588939 15.715103 4.709412 20.936407-19.451919-9.060499zM700.780976 943.878774l-17.404348-12.490179 20.475704-6.24509 6.552225-20.424515 12.234233 17.609106 21.448301-0.102379-12.950883 17.097213 6.756982 20.322136-20.270947-7.012928-17.30197 12.694936 0.460703-21.4483zM303.552315 278.827902l-21.192354 3.42968 10.135473-18.888837-9.828338-19.042405 21.089976 3.788006 15.100832-15.2544 2.917787 21.243543 19.144784 9.623581-19.298351 9.316445-3.224924 21.243544-14.844885-15.459157z"
                          fill="#13C463" p-id="3490"></path>
                        <path
                          d="M407.620081 90.604991a486.861057 486.861057 0 0 1 504.521352 11.77353l25.031548-14.435371a511.892605 511.892605 0 0 0-797.528678 459.57718l25.031548-14.384182A486.758678 486.758678 0 0 1 407.620081 90.604991zM893.201406 933.333787a486.861057 486.861057 0 0 1-504.521351-11.619963l-24.980359 14.384183A511.892605 511.892605 0 0 0 1161.177185 476.572015L1136.401583 490.956197a486.912246 486.912246 0 0 1-243.200177 442.37759z"
                          fill="#13C463" p-id="3491"></path>
                        <path
                          d="M813.909242 795.839433a326.587482 326.587482 0 0 1-258.147441 29.536203l-29.792149 17.199592a353.205897 353.205897 0 0 0 472.73282-272.429245l-29.792149 17.148403A326.843428 326.843428 0 0 1 813.909242 795.839433zM486.861057 228.099345a326.587482 326.587482 0 0 1 258.14744-29.536204l29.79215-17.199591A353.205897 353.205897 0 0 0 302.016637 453.792794l29.843339-17.148402a326.485103 326.485103 0 0 1 155.001081-208.545047zM1288.280119 374.705387a53.441588 53.441588 0 0 1-14.384182 11.978287l-1044.260914 601.934514a53.799913 53.799913 0 0 1-73.4054-19.759055L7.217686 710.660503a53.697534 53.697534 0 0 1 19.707865-73.405399L1071.442411 35.32059a53.799913 53.799913 0 0 1 73.4054 19.759054l148.80718 258.19863a53.953481 53.953481 0 0 1-5.374872 61.427113zM32.198045 665.716333a28.102904 28.102904 0 0 0-2.815409 32.146855l148.80718 258.19863a28.154093 28.154093 0 0 0 38.443134 10.237852L1261.149811 364.518724a28.154093 28.154093 0 0 0 10.237852-38.443135l-148.755991-258.249819a28.102904 28.102904 0 0 0-38.391945-10.237852L39.722866 659.420054a27.130308 27.130308 0 0 0-7.524821 6.296279z"
                          fill="#13C463" p-id="3492"></path>
                        <path
                          d="M585.451572 548.134601l-136.419379 78.780272 38.135999 65.982957q7.831957 13.667533 21.294732 5.886765l112.616374-65.010361a20.73165 20.73165 0 0 0 9.828338-10.954502q2.610652-9.67477-16.687699-46.684605l18.172187-4.043952q20.475704 42.640654 17.916241 55.38678a35.525347 35.525347 0 0 1-15.91986 19.144784L512.967579 716.649647q-24.877981 14.332993-39.876434-11.619962L406.186782 589.188388l15.817482-9.111688L440.22764 611.711663l120.345952-69.463827-33.119452-57.43435-148.09053 85.486065-8.855743-15.356778 164.11277-94.751321zM657.065348 463.672322l46.428659-26.771984L758.522462 532.368309c1.023785-3.941573 2.149949-8.497417 3.276113-13.667532l1.740435-7.166497 1.791624-7.473632 14.077046 14.179425a336.467009 336.467009 0 0 1-16.687699 53.236831l-14.435371-10.698555a13.923479 13.923479 0 0 0-0.460703-12.029477l-50.677368-87.789581-31.020692 17.916241z m45.302495-68.388852l-4.402276 17.25078a250.315484 250.315484 0 0 0-56.308187-11.875908l4.760602-17.148402a299.71312 299.71312 0 0 1 55.949861 11.77353z m58.611703 88.813366l63.167548-36.344374a198.563141 198.563141 0 0 0-9.214067-20.475705l-21.704246-37.572917 15.356778-8.906931 21.704246 37.624106a185.407502 185.407502 0 0 1 9.418824 20.475704l53.441588-30.713556 8.395039 14.53775L844.622798 455.174904a49.14169 49.14169 0 0 1 1.228542 5.118926l0.767839 4.811791a375.422036 375.422036 0 0 1 83.489684 3.42968l-1.074974 18.479323a341.893071 341.893071 0 0 0-81.902817-6.449846 55.898672 55.898672 0 0 1-0.66546 9.470013q-5.118926 31.430206-37.163404 65.72701L793.433538 547.725087q31.481395-32.863505 35.832482-60.86403a104.477281 104.477281 0 0 0-0.767839-22.16495L769.374585 498.583397z m-55.386779-118.247191l48.834554-28.000526-9.367635-16.278185 15.356779-9.009309 9.418824 16.278184 49.192879-28.410039 8.241471 14.332993-48.936933 28.205282 11.05688 19.144784 53.236831-30.713557 5.835576 10.237853a321.673313 321.673313 0 0 1 9.828338 50.011907l-17.967431 4.504655a183.001606 183.001606 0 0 0-5.937954-40.439516L723.969711 419.751936l-8.497417-14.742507 58.304568-33.631344-11.056881-19.40073-48.834554 28.205283zM795.481108 445.346566l-0.921407 16.687699a181.977821 181.977821 0 0 0-46.735794-3.788005l1.33092-15.356778a175.988678 175.988678 0 0 1 46.326281 2.457084z m2.713031-32.914694l-1.074975 15.868671a156.024866 156.024866 0 0 0-43.920385-3.378492l1.38211-14.896074a195.389407 195.389407 0 0 1 43.61325 2.405895z"
                          fill="#13C463" p-id="3493"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </van-list>
            </div>
            <empty v-else></empty>
          </template>

          <div class="list-skeleton-container" v-if="!loadingEnd">
            <div class="skeleton"></div>
            <div class="skeleton"></div>
            <div class="skeleton"></div>
            <div class="skeleton"></div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="page-flow-todo-container" v-else-if="todoType === 'ASSIGN_APP'">
      <flowTodoContainer
        :app-id="appId">
      </flowTodoContainer>
    </div>
  </div>
</template>

<script>
  import {formatDate} from "../../RyForm/utils";
  import flowTodoContainer from "../../component/flowTodoContainer";
  import {FORM_ITEM__IMAGE} from "../../RyForm/types";
  import {ImagePreview} from 'vant'

  export default {
    inject: ['reload'],
    components: {
      flowTodoContainer
    },
    data() {
      return {
        FORM_ITEM__IMAGE,
        title: '',
        appId: '',
        todoType: '',

        // 团队工作台参数
        loadingEnd: false,
        menuList: [],
        activeIndex: null,
        formApplyStatusMap: {
          AGREE: {
            tagType: 'success',
            tagContent: '完成'
          },
          RUNNING: {
            tagType: 'warning',
            tagContent: '进行中'
          },
          OVERTIME: {
            tagType: 'danger',
            tagContent: '超期'
          },
          REJECT: {
            tagType: 'danger',
            tagContent: '拒绝'
          }
        },
        pageConf: {
          currentPage: 0,
          pageSize: 20,
          totalPage: 0,
          totalCount: 0,
          timestamp: 0,
          sort: -1,
        },
        loading: false,
        finished: false,
        dataList: [],
        filter: null,
        searchInputText: '',

        showUnread: 'NO'
      }
    },
    async created() {

      this.showUnread = localStorage.getItem('todo_showUnread') || 'NO'

      const pageConfig = await this.$store.dispatch('actionSpacePageConfigDetail', {
        spaceId: this.$route.params.spaceId,
        pageConfigId: this.$route.params.pageConfigId
      }).catch(console.error)

      this.title = pageConfig.pageTitle
      this.$store.dispatch('setPageTitle', this.title)
      const pageDetailConfig = pageConfig.pageConfigDetail || {}

      this.appId = pageDetailConfig.appId
      this.todoType = pageDetailConfig.todoType

      this.$store.commit('UPDATE__APP_ID', this.appId)

      if (this.todoType === 'WORKBENCH') {
        const tabActive = sessionStorage.getItem('tabActive');
        sessionStorage.removeItem('tabActive')

        this.$store.dispatch("actionWorkspaceNewTabList")
          .then(res => {
            this.menuList.splice(0, this.menuList.length, ...res)
            if (this.menuList && this.menuList.length > 0) {
              if (tabActive) {
                this.activeIndex = tabActive
              } else {
                // 找到有数据的tab
                this.activeIndex = this.menuList[0].id
                this.menuList.some(item => {
                  if (item.count > 0) {
                    this.activeIndex = item.id
                  }
                  return item.count > 0
                })
              }
            }
            this.fetchData()
          })
      }

    },
    methods: {
      // 团队工作台

      // 请求 menu 列表
      fetchTabList() {
        this.$store.dispatch("actionWorkspaceNewTabList")
          .then(res => {
            this.menuList.splice(0, this.menuList.length, ...res)
          })
      },
      // 请求列表数据
      fetchData(filter) {
        filter = filter || {}
        this.loading = true
        this.pageConf.currentPage++
        const {
          appId = "",
          formId = "",
          stepId = "",
          filterUser = null,
          filterTime = null,
          filterFlowState = null,
          pressToDo = -1,
          timeOut = -1,
          willTimeOut = -1
        } = filter
        this.fetchTabList()
        this.$store.dispatch('actionWorkspaceTabData', {
          id: this.activeIndex,
          currentPage: this.pageConf.currentPage,
          pageSize: this.pageConf.pageSize,
          sort: this.pageConf.sort,
          appId,
          formId,
          stepId,
          filterUser,
          filterTime,
          filterFlowState,
          remindFlag: pressToDo,
          timeoutFlag: timeOut,
          preRemindFlag: willTimeOut,
          ccUnread: this.showUnread
        }).then(({currentPage, pageSize, totalPage, totalCount, timestamp, dataList}) => {
          this.pageConf.currentPage = currentPage
          this.pageConf.pageSize = pageSize
          this.pageConf.totalPage = totalPage
          this.pageConf.totalCount = totalCount
          this.pageConf.timestamp = timestamp

          if (this.pageConf.currentPage === 1) {
            this.dataList.splice(0, this.dataList.length, ...dataList)
          } else {
            this.dataList.push(...dataList)
          }
          if (totalPage <= currentPage) {
            this.finished = true
          }
        })
          .catch(console.error)
          .finally(() => {
            this.loadingEnd = true
            this.loading = false
          })
      },
      // menu选中操作
      handleSelect(activeIndex) {
        this.loadingEnd = false
        let pageContainer = document.getElementById(`listContainerBody${this.activeIndex}`)
        if (pageContainer) pageContainer.scrollTop = 0
        this.activeIndex = activeIndex
        this.clearPage()
        this.filter = null
        this.searchInputText = ''
        this.fetchData(this.filter)
      },
      // 列表单项被点击时
      onClickFormItem(item) {
        sessionStorage.setItem('tabActive', this.activeIndex);
        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('reqNodeSave', {
          companyId: this.$store.getters.currentCompanyId,
          userId: this.$store.getters.userId,
          appId: item.appId,
          formId: item.formId,
          formName: item.formName,
          instanceId: item.instanceId,
          formApplyStatus: item.formApplyStatus,
          stepId: item.stepId,
          stepName: item.stepName,
          recordId: item.recordId,
          pageType: 'other',
          token: this.$store.state.token,
          userInfo: this.$store.getters.userInfo
        })
          .then(res => {
            this.$router.push({
              name: 'handleFormWrapper',
              query: {
                key: res.nodeKey
              }
            })
          })
          .catch(err => {
            console.error(err)
          })
          .finally(() => {
            toast.clear()
          })
      },
      loadMoreData() {
        this.fetchData(this.filter)
      },
      clearPage() {
        this.pageConf.currentPage = 0
        this.pageConf.totalPage = 1
        this.pageConf.totalCount = 11
        this.pageConf.sort = -1
        this.loading = false
        this.finished = false
      },
      formatTime(d) {
        return formatDate(d)('yyyy-MM-dd HH:mm')
      },
      previewImage(values, idx) {
        if (window.isLark) {
          console.log('urls', values.map(item => item.imgUrl))
          console.log('current', values.map(item => item.imgUrl)[idx])
          this.$tt.ready(() => {

            const urls = values.map(item => item.imgUrl)
            this.$tt.biz.util.previewImage({
              urls,
              current: urls[idx]
            });

          })

        } else {
          ImagePreview({
            images: values.map(item => item.imgUrl),
            startPosition: idx
          })
        }
      },

      showUnreadChange() {
        localStorage.setItem('todo_showUnread', this.showUnread)
        this.pageConf.currentPage = 0
        this.fetchData(this.filter)
      },
      allRead() {
        this.$store.dispatch('actionCcAllRead', {
          appId: '',
        }).then(res => {
          this.pageConf.currentPage = 0
          this.fetchData(this.filter)
          this.$toast.success('设置成功')
        }).catch(console.error)
      }
    }
  }
</script>

<style lang="less">

  .todo-task-container {
    height: 100%;

    .work-station-page-container {
      height: 100%;

      .van-tabs {
        height: 100%;
        overflow: hidden;

        .van-tabs__content {
          height: calc(100% - 44px);

          .van-tab__pane {
            height: 100%;
          }
        }

        .cc-header {
          height: 40px;
          background-color: #FFFFFF;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding: 0 10px;
        }
        .list-container {
          height: 100%;
          overflow: auto;
          -webkit-overflow-scrolling: touch;

          .card-container {

            .card-item {
              background-color: #ffffff;
              padding: 10px;
              border-radius: 5px;
              margin: 10px 14px;
              position: relative;

              .form-name {
                line-height: 20px;
                display: flex;
                align-items: center;
                margin-bottom: 10px;

                .header-name {
                  width: calc(100% - 100px);
                  font-size: 13px;
                  color: #333333;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }

                .dead-line {
                  width: 200px;
                  font-size: 12px;
                  color: #9F9F9F;
                }
              }
              .title {
                line-height: 20px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(40, 40, 40, 1);
                margin-bottom: 10px;
              }

              .prompt-container {
                margin-bottom: 10px;
                display: flex;
                align-items: center;
              }

              .must-arrive {
                margin: 0 10px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(247, 98, 96, 1);
                display: flex;
                align-items: center;
              }

              .will-timeout {
                margin: 0 10px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(247, 98, 96, 1);
                display: flex;
                align-items: center;
              }

              .sub-des {
                line-height: 18px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(40, 40, 40, 1);
                margin-bottom: 10px;
              }

              .form-item-brief-report {
                display: flex;
                margin-bottom: 10px;
                align-items: center;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                .field-name {
                  font-size: 13px;
                  color: #8f959e;
                  display: inline-block;
                  -webkit-box-flex: 0;
                  -ms-flex: none;
                  flex: none;
                  max-width: 100px;
                }

                .field-value {
                  font-size: 13px;
                  color: #333333;
                  display: inline-block;
                  -webkit-box-flex: 1;
                  -ms-flex: auto;
                  flex: auto;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }

              .user {
                display: flex;
                align-items: center;
                margin-bottom: 5px;
                margin-top: -5px;
              }

              .van-image {
                margin-right: 10px;
              }

              .dead-line {
                /*margin-bottom: 0;*/
              }

              .read-icon {
                position: absolute;
                top: 0;
                right: 10px;
              }
            }
          }
        }

        .list-skeleton-container {
          height: 100%;
          background-color: #ffffff;
          padding-top: 10px;

          .skeleton {
            margin: 10px;
            position: relative;
            width: calc(100% - 20px);
            height: 140px;
            background-color: #f2f3f5;
            border-radius: 10px;
            border: 1px solid #ebeef5;
          }
        }

        .apply-no-data {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-color: #fff;

          img {
            width: 300px;
            height: 222px;
            margin-bottom: 20px;
          }

        }
      }
    }

    .page-flow-todo-container {
      height: 100%;
    }
  }

</style>